import { useMemo } from 'react';
import { Table } from 'redesign';
import { ServiceAgreementState } from '@levelworks/shared-domain-types';
import { useServiceAgreementsColumnDefinition } from './use-service-agreements-column-definition';

type ServiceAgreementsProps = {
  serviceAgreements: {
    id: string;
    name: string;
    state: ServiceAgreementState;
  }[];
};

export const ServiceAgreements = ({ serviceAgreements }: ServiceAgreementsProps) => {
  const columns = useServiceAgreementsColumnDefinition();
  const tableData = useMemo(() => serviceAgreements, [serviceAgreements]);

  return <Table stickyHeader data={tableData} columns={[columns.name, columns.state]} />;
};
